<template>
  <section class="base-rating relative">
    <div :class="text ? 'is-text' : ''"
         :tooltip-question="question"
         :tooltip-text="text ? text : ''">
      <span v-for="(item, index) in 5"
            :key="index">
        <svg :class="{'is-rated': index < rating }" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5152 4.9298L10.0185 4.29107L8.00833 0.308118C7.95343 0.199068 7.8631 0.110788 7.75153 0.0571283C7.4717 -0.0778871 7.13166 0.0346257 6.99174 0.308118L4.9816 4.29107L0.484887 4.9298C0.360913 4.94711 0.247566 5.00423 0.160784 5.09078C0.0558699 5.19617 -0.00194268 5.33796 4.9848e-05 5.48499C0.00204238 5.63202 0.063677 5.77227 0.17141 5.87491L3.42484 8.97507L2.6562 13.3527C2.63818 13.4545 2.64971 13.5592 2.68948 13.655C2.72926 13.7508 2.79569 13.8337 2.88125 13.8944C2.9668 13.9552 3.06805 13.9912 3.17353 13.9986C3.279 14.0059 3.38446 13.9843 3.47797 13.936L7.50004 11.8692L11.5221 13.936C11.6319 13.9931 11.7594 14.0122 11.8816 13.9914C12.1898 13.9395 12.397 13.6539 12.3439 13.3527L11.5752 8.97507L14.8287 5.87491C14.9172 5.79009 14.9757 5.67931 14.9934 5.55814C15.0412 5.25522 14.8251 4.9748 14.5152 4.9298Z" fill="#C0C0C0"/>
        </svg>
      </span>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Rating',
    props: {
      index: Number,
      rating: Number,
      question: String,
      text: String
    }
  }
</script>

<style lang="less">
  .base-rating {
    div {
      width: 108px;
      font-size: 1.4rem;
    }
    span {
      display: inline-block;
      margin-right: 2px;
    }
    .is-text:after {
      display: block!important;
    }
    .is-rated {
      path {
        fill: orange;
      }
    }
  }
</style>
